import { Subscription } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { TimelineSubscriptionQl } from './timeline-subscription-ql';

@Injectable({
  providedIn: 'root'
})
export class TimelineSubscription extends Subscription {
  document = TimelineSubscriptionQl;
}
